import {createRouter, createWebHashHistory} from "vue-router"
import AdminApi from "xpark-shared/services/admin-api"
import HomeView from "../views/HomeView.vue"

const routes = [
    {
        path: "/",
        name: "home",
        component: HomeView
    },
    {
        path: "/register/:registerId",
        name: "register",
        component: () => import(/* webpackChunkName: "register" */ "../views/RegisterView.vue")
    },
    {
        path: "/intro",
        name: "intro",
        component: () => import(/* webpackChunkName: "intro" */ "../views/BriefingView.vue")
    },
    {
        path: "/register-signage/:signageId",
        name: "signage",
        component: () => import(/* webpackChunkName: "signage" */ "../views/RegisterSignageView.vue")
    },
    {
        path: "/outro/:outroId",
        name: "outro",
        component: () => import(/* webpackChunkName: "outro" */ "../views/OutroView.vue")
    },
    {
        path: "/leaderboards",
        name: "leaderboards",
        component: () => import(/* webpackChunkName: "leaderboards" */ "../views/LeaderBoardsView.vue")
    },
    {
        path: "/leaderboards-alltime/:type?",
        name: "leaderboards-alltime",
        component: () => import(/* webpackChunkName: "leaderboards" */ "../views/LeaderBoardsAllTimeView.vue")
    },
    {
        path: "/leaderboards-daily",
        name: "leaderboards-daily",
        component: () => import(/* webpackChunkName: "leaderboards" */ "../views/LeaderBoardsDailyView.vue")
    },
    {
        path: "/leaderboards-daily-single",
        name: "leaderboards-daily-single",
        component: () => import(/* webpackChunkName: "leaderboards" */ "../views/LeaderBoardsDailySingleView.vue")
    },
    {
        path: "/carousel/:carouselId",
        name: "carousel",
        component: () => import(/* webpackChunkName: "leaderboards" */ "../views/CarouselView.vue")
    },
    {
        path: "/games",
        name: "games",
        component: () => import(/* webpackChunkName: "games" */ "../views/GameListView.vue")
    },
    {
        path: "/game/:gameId",
        name: "game",
        component: () => import(/* webpackChunkName: "games" */ "../views/GameView.vue")
    },
    {
        path: "/game/02-stopez-le-reacteur-output",
        name: "game-02-stopez-le-reacteur-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/02-stopez-le-reacteur-output.vue")
    },
    {
        path: "/game/16-lheritier-de-Jack-leventreur-output",
        name: "game-16-lheritier-de-Jack-leventreur-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/16-lheritier-de-Jack-leventreur-output.vue")
    },
    {
        path: "/game/17-disco-quiz-output",
        name: "game-17-disco-quiz-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/17-disco-quiz-output.vue")
    },
    {
        path: "/game/21-rythme-des-tambours-output",
        name: "game-21-rythme-des-tambours-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/21-rythme-des-tambours-output.vue")
    },
    {
        path: "/game/32-SOS-output",
        name: "game-32-SOS-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/32-SOS-output.vue")
    },
    {
        path: "/game/60-maison-penchee-output",
        name: "game-60-maison-penchee-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/60-maison-penchee-output.vue")
    },
    {
        path: "/game/61-memoire-de-sally-output",
        name: "game-61-memoire-de-sally-output",
        component: () => import(/* webpackChunkName: "games" */ "../views/games/61-memoire-de-sally-output.vue")
    },

    /*
        admin dashboard
    */
    {
        path: "/admin/login",
        name: "admin-login",
        component: () => import(/* webpackChunkName: "AdminLogin" */ "../views/admin/AdminLogin.vue")
    },
    {
        path: "/admin",
        name: "admin",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "TeamsView" */ "../views/admin/RegisterView.vue")
    },
    {
        path: "/admin/register",
        name: "admin-register",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "RegisterView" */ "../views/admin/RegisterView.vue")
    },
    {
        path: "/admin/teams",
        name: "admin-teams",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "TeamsView" */ "../views/admin/TeamsView.vue")
    },
    {
        path: "/admin/rooms",
        name: "admin-rooms",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "RoomsView" */ "../views/admin/RoomsView.vue")
    },
    {
        path: "/admin/bookings",
        name: "admin-bookings",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "RoomsView" */ "../views/admin/AdminBookingsView.vue")
    },
    {
        path: "/admin/export",
        name: "admin-export",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "AdminExport" */ "../views/admin/AdminExportView.vue")
    },
    {
        path: "/admin/settings",
        name: "admin-settings",
        meta: {
            requireLogin: true
        },
        component: () => import(/* webpackChunkName: "settingsView" */ "../views/admin/SettingsView.vue")
    },

    /*
        misc
    */
    {
        path: "/artnet",
        name: "artnet",
        component: () => import(/* webpackChunkName: "Arntet" */ "../views/ArtnetTester.vue")
    },
    {
        path: "/djembe-recorder",
        name: "djembe-recorder",
        component: () => import(/* webpackChunkName: "DjembeRecorder" */ "../views/DjembeRecorder.vue")
    },

    /*
        404
    */
    {
        path: "/:catchAll(.*)",
        name: "404",
        component: () => import(/* webpackChunkName: "PageNotFound" */ "../views/PageNotFound.vue")
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach(async (to) => {
    if (to.matched.some(record => record.meta.requireLogin)) {
        const adminUser = JSON.parse(await localStorage.getItem("admin-user") as any)
        let hashValid = false

        if (adminUser) {
            hashValid = (await AdminApi.validateHash(adminUser.hash)).valid === true
        }
        if ((!adminUser || !hashValid) && to.name !== "admin-login") {
            return {name: "admin-login"}
        }
    }
})

export default router
